import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../Context/ProductDetailContext.js';
import { useSolutionsEcommContext } from '../context/SolutionsEcommContext.js';

const useGetSolutionsLoyaltyPoints = ()=>{
    const { activeVariant: { loyaltyPoints , loyaltyPointsWithSubscription  } ,  } = useProductDetailContext();
    const { state  } = useSolutionsEcommContext();
    const subscriptionPurchase = isSubscriptionPurchase(state.configurations.purchaseType);
    const solutionsLoyaltyPoints = subscriptionPurchase ? loyaltyPointsWithSubscription : loyaltyPoints;
    if (!solutionsLoyaltyPoints) {
        return undefined;
    }
    return solutionsLoyaltyPoints * state.configurations.quantity;
};

export { useGetSolutionsLoyaltyPoints };
//# sourceMappingURL=use-get-solutions-loyalty-points.js.map
